function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--icon-color, currentColor)"
    },
    d: "M21.028 19.528L18.583 22.585C14.7964 20.3592 11.6408 17.2036 9.415 13.417L12.472 10.972C12.83 10.6851 13.0829 10.2878 13.1915 9.84213C13.3 9.39642 13.258 8.92733 13.072 8.50799L10.286 2.23499C10.0865 1.78482 9.73354 1.42021 9.29006 1.20626C8.84659 0.992307 8.34151 0.942946 7.865 1.06699L2.565 2.44299C2.06946 2.5713 1.63832 2.87716 1.35348 3.30248C1.06865 3.72779 0.949974 4.24292 1.02 4.74999C1.95075 11.3774 5.01377 17.5217 9.74605 22.2539C14.4783 26.9862 20.6226 30.0492 27.25 30.98C27.7565 31.0499 28.2711 30.9315 28.6961 30.6473C29.1211 30.3631 29.4271 29.9328 29.556 29.438L30.932 24.138C31.0554 23.6619 31.0058 23.1575 30.7921 22.7145C30.5784 22.2715 30.2144 21.9187 29.765 21.719L23.492 18.93C23.0729 18.7436 22.6039 18.7012 22.1582 18.8094C21.7124 18.9176 21.315 19.1702 21.028 19.528Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.357fe84e5aa935b9d96e2c0d29f44987.svg";
export { ForwardRef as ReactComponent };